module.exports = __webpack_public_path__ + "img/one.33de41ab.png";